module.exports = __webpack_public_path__ + "r-v3/img/screen_share.80b7c3a5.svg";